import { Modal, ModalContent } from 'src/shared/ui/components/Modal';


import { useUser } from '@legacy-hooks/api/users/useUser';
import { CertificateForm } from '@shared/certificates/components/CertificateForm';
import { createCertificateForUserAndCompany } from '@shared/certificates/endpoints/createCertificateForUserAndCompany';
import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { ModalTrigger } from '@shared/ui/components/Modal/ModalTrigger';

type CreateUserCertificateButtonProps = {
  userId: number;
};

export function CreateUserCertificateButton({ userId }: CreateUserCertificateButtonProps) {
  const user = useUser(userId);
  const companies = (user.data?.companies || []).map((company) => ({
    label: company.name,
    value: company.id,
  }));

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button size="sm">
          <Icon icon="plus" /> Create
        </Button>
      </ModalTrigger>
      <ModalContent title="Upload Certificate" size="2xl" withoutAutoFocus>
        {({ close }) => (
          <CertificateForm
            companies={companies}
            action={function (data) {
              if (!data.companyId) {
                throw new Error('Company ID is required');
              }

              return createCertificateForUserAndCompany(userId, data.companyId, data);
            }}
            onSave={() => {
              close();
            }}
            onCancel={close}
          />
        )}
      </ModalContent>
    </Modal>
  );
}
